module.exports = __webpack_public_path__ + "img/diilistirio.837d461a.png";